import script from "./dialGauge2.vue?vue&type=script&setup=true&lang=js"
export * from "./dialGauge2.vue?vue&type=script&setup=true&lang=js"

import "./dialGauge2.vue?vue&type=style&index=0&id=64f101b2&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f101b2"]])

export default __exports__